var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4015_1287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9993 20.0784C4.04082 20.0784 0.00463882 16.0966 3.76158e-06 11.1979C-0.00449629 6.29617 4.02921 2.30593 8.99165 2.30059H9.0003C13.9587 2.30059 17.9949 6.27444 17.9995 11.1633L18 11.8406H3.77816C3.39966 11.8406 3.09276 11.538 3.09276 11.1642C3.09276 10.79 3.39966 10.4869 3.77816 10.4869H16.5976C16.2457 6.66112 12.9715 3.654 9.00007 3.654H8.99278C4.78608 3.65844 1.36662 7.04153 1.37027 11.1966C1.37432 15.3491 4.79603 18.7251 8.99908 18.7251H9.00637C11.2819 18.7251 13.4207 17.7287 14.8745 15.9971C15.1164 15.7091 15.548 15.6696 15.8396 15.9078C16.1309 16.1465 16.171 16.5736 15.9295 16.8611C14.2146 18.9038 11.6916 20.0761 9.00767 20.0784H8.9993Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4015_1287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -55,
    y: -20,
    width: 649,
    height: 1148
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-54.0586 1127.47H593.949V-19.6367H-54.0586V1127.47Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4015_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.25 0.0783138H20.2503V22.3005H-2.25V0.0783138Z",
    fill: "#253965"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 10,
    height: 1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54092 0.888916C5.21498 0.888916 4.95051 0.691618 4.9502 0.447618C4.94988 0.203174 5.21404 0.00546283 5.54061 0.00501835L12.4593 2.70605e-05C12.7855 2.70605e-05 13.05 0.197867 13.0503 0.441867C13.0506 0.686312 12.7865 0.884033 12.4603 0.884033L5.54092 0.888916Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4015_1287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -55,
    y: -41,
    width: 649,
    height: 1148
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-54.0586 1106.51H593.949V-40.604H-54.0586V1106.51Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4015_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 -2.222H15.3003V3.11133H2.7002V-2.222Z",
    fill: "#A33943"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 21,
    width: 10,
    height: 2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54097 22.3789C5.21503 22.3789 4.95051 22.1816 4.9502 21.9376C4.94988 21.6936 5.21404 21.4959 5.54061 21.4954L12.4592 21.49C12.7855 21.49 13.05 21.6879 13.0503 21.9319C13.0506 22.1759 12.7865 22.374 12.4602 22.374L5.54097 22.3789Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4015_1287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -55,
    y: -22,
    width: 649,
    height: 1148
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-54.0586 1125.77H593.949V-21.3362H-54.0586V1125.77Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4015_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 19.2677H15.3003V24.6011H2.7002V19.2677Z",
    fill: "#253965"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 23,
    width: 10,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54092 24.6797C5.21498 24.6797 4.95051 24.482 4.9502 24.238C4.94988 23.994 5.21404 23.7957 5.54061 23.7952L12.4589 23.7908C12.7849 23.7908 13.0498 23.9891 13.0501 24.2331C13.0504 24.4771 12.786 24.6749 12.4597 24.6753L5.54092 24.6797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4015_1287)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4015_1287",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -55,
    y: -22,
    width: 649,
    height: 1148
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-54.0586 1125.85H593.949V-21.2576H-54.0586V1125.85Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4015_1287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 21.5685H15.3003V26.9019H2.7002V21.5685Z",
    fill: "#D7D8D6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4015_1287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b7423a7f6dae44136e011a2c201a900.svg";
export { ForwardRef as ReactComponent };